module.exports = __webpack_public_path__ + "static/media/how_it_works_en.ed4876dd.jpg";